export default 'favoriteAssets'
